module.exports = __webpack_public_path__ + "img/avatar_ico6.243a1b0f.jpg";